export class SearchFilter {
  pageNumber: Number;
  pageSize: Number; 
  sortBy: string;
  mode: boolean; 
}

export class Sort {
  sortType: string;
  sortReverse: boolean;
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/entities/searchFilter.ts